/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 function checkUrl() {
    let orderSize = 1; // for product page
    const increase = document.getElementById("button_plus");
    const decrease = document.getElementById("button_minus");
    const qttField = document.getElementById("quantity_field");
    const btns = document.getElementById("btn");
    const urlPath = window.location.pathname;
   	const mindestText = document.getElementsByClassName("product-meta__text rte");
   	const quick_view_buy = document.getElementsByClassName("quick-view-buy-btn");


    if (urlPath.includes("products")) { //if "product" is in url or the path is xx/xx/product, then check for metafield value
       // set metaVal to the products metavalue
       // set an event listener that checks whenever quantity is changed
    
        if (metaVal > 1 && metaVal != null) {
            btns.style.visibility = 'hidden';
          
        }

        //input new value
        qttField.addEventListener('input', function (updateValue) {
            orderSize = this.value;

            if (orderSize >= metaVal) {
                btns.style.visibility = 'visible';
              
              	//for (let i = 0; i < mindestText.length; i++) {
    				mindestText[1].style.visibility = 'visible'; 
				//}
              
            }else {
                btns.style.visibility = 'hidden';
              	//for (let i = 0; i < mindestText.length; i++) {
    				mindestText[1].style.visibility = 'hidden'; 
				//}
            }
        })

        // click on Plus
        increase.addEventListener("click", increaseQuantity => {
            orderSize ++;
          
            if (orderSize >= metaVal) {
                btns.style.visibility = 'visible';
              	//for (let i = 0; i < mindestText.length; i++) {
    				mindestText[1].style.visibility = 'hidden'; 
				//}
            }
        })

        // click on Minus
        decrease.addEventListener("click", decreaseQuantity => {
            
            if (orderSize > 1) {
                orderSize --;
                
            } 
                
            if (orderSize < metaVal) {
               btns.style.visibility = 'hidden';
              //for (let i = 0; i < mindestText.length; i++) {
    				mindestText[1 ].style.visibility = 'visible'; 
				//}
            }
            
        })   
    }
   	else if (urlPath.includes("products")) {
       
      for (let i = 0; i < quick_view_buy.length; i++) {
        quick_view_buy[i].style.visibility = 'visible';
	  }
   }
}

checkUrl();